import {
  SidePanelDS,
  TextCapitalized,
  Spacer,
  InputDS,
  triggerToast,
} from "@qivia/ui";
import { useState, useCallback, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useAppDispatch, useAppSelector } from "../../../../redux/hooks";
import {
  vehiclesSlice,
  selectVehicleAnalyticCodeUpdatedStatus,
  updateVehicleAnalyticCodeAsync,
} from "../vehiclesSlice";
import styled from "styled-components";
import { typographies } from "@qivia/ui/src/styles/figmaTypographies";
import { colors } from "@qivia/ui/src/styles/figmaColors";
import { selectCompany } from "../../homeSlice";

export const AnalyticCodeSection = (props: {
  analyticCode: string | null;
  vehicleUuid: string;
}) => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const company = useAppSelector(selectCompany);
  const vehicleAnalyticCodeUpdatedStatus = useAppSelector(
    selectVehicleAnalyticCodeUpdatedStatus,
  );
  const [analyticCode, setAnalyticCode] = useState<string>(
    props.analyticCode ?? "",
  );

  useEffect(() => {
    if (vehicleAnalyticCodeUpdatedStatus === "success") {
      triggerToast(t(`vehicles.updatedAnalyticCode.success`) || "", "valid");
      dispatch(vehiclesSlice.actions.resetVehicleUpdatedAnalyticCodeStatus());
    } else if (vehicleAnalyticCodeUpdatedStatus === "failed") {
      triggerToast(t("vehicles.updatedAnalyticCode.failure") || "", "error");
      dispatch(vehiclesSlice.actions.resetVehicleUpdatedAnalyticCodeStatus());
    }
  }, [dispatch, vehicleAnalyticCodeUpdatedStatus, t]);

  const onClick = useCallback(() => {
    if (!company) {
      return;
    }
    void dispatch(
      updateVehicleAnalyticCodeAsync({
        vehicleUuid: props.vehicleUuid,
        analyticCode,
        companyUuid: company.uuid,
      }),
    );
  }, [company, dispatch, props.vehicleUuid, analyticCode]);

  if (!company) {
    return;
  }

  return (
    <SidePanelDS.Section verticalSpacing={1.5} horizontalSpacing={1.5}>
      <SectionTitle>
        <TextCapitalized>
          {t("vehicles.sidepanel.analyticCode.title")}
        </TextCapitalized>
      </SectionTitle>
      <Spacer y={1} />
      <StyledFlex>
        <InputDS
          placeholder={t("vehicles.sidepanel.analyticCode.placeholder")}
          value={analyticCode}
          onChange={(e) => setAnalyticCode(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              onClick();
              (e.target as HTMLInputElement).blur();
            }
          }}
          withoutSpacerBottom
          onBlur={() => onClick()}
        />
      </StyledFlex>
    </SidePanelDS.Section>
  );
};

const SectionTitle = styled.div`
  ${typographies["Body/L"]}
  color: ${colors["colors/text/darkGrey"]}
`;

const StyledFlex = styled.div`
  display: flex;
`;
